<div class="navBar">
  <div class="navBar-btn">
    <button (click)="backToTransaction()"
      class="backToReport"><mat-icon>keyboard_arrow_left</mat-icon>
      <span>{{reportService.isProjectDetailOpen() ? ('User.Back'|translate) :
        ('reports.backToReport'|translate)}}</span> </button>
  </div>

  <div class="property-detailMenu" [ngClass]="{ 'property-detailMenuAr' : currentReportView === 2}">
    <app-report-sub-menu [menuList]="overViewMenu" [isPropertyDetailPage]="true"
      (menuChangeValue)="menuChangeValue($event)" [activeTabName]="'property'"></app-report-sub-menu>
  </div>
</div>

<div class="report-property-detail">
  <!-- Overview Section -->
  <div class="report-tabsection-d" id="{{ officePropertyDetailMenuEnum.overview}}"
    [ngClass]="{ 'scroll': currentScroll === officePropertyDetailMenuEnum.overview}">
    <app-property-details-overview [Property_Uid]="propertyInfo?.property_uid"
      [property_cat]="'multi_story_office'"></app-property-details-overview>
  </div>
  <!-- Overview Section -->

  <!-- Units Rental-->
  <div class="report-model report-tabsection-d" id="{{ officePropertyDetailMenuEnum.unitRental}}"
    [ngClass]="{ 'scroll': currentScroll === officePropertyDetailMenuEnum.unitRental}">
    <app-office-unit-rental [propertyInfo]="propertyInfo"
      [report_category]="propertyCategory.MultiStoryOffice"></app-office-unit-rental>
  </div>
  <!--Units Rental-->


  <!-- Property Transaction -->
  <div class="report-model report-tabsection-d" id="{{ officePropertyDetailMenuEnum.propertyTransaction}}"
    [ngClass]="{ 'scroll': currentScroll === officePropertyDetailMenuEnum.propertyTransaction}">
    <app-property-transaction [propertyInfo]="propertyInfo"
      [report_category]="propertyCategory.MultiStoryOffice"></app-property-transaction>
  </div>
  <!-- Property Transaction -->

  <!-- Office Rent - unit size wise -->
  <div class="report-model report-tabsection-d" id="{{ officePropertyDetailMenuEnum.officeRentUnitSizeWise}}"
    [ngClass]="{ 'scroll': currentScroll === officePropertyDetailMenuEnum.officeRentUnitSizeWise}">
    <app-rent-unit-size-wise [propertyInfo]="propertyInfo" [tableHeading]="'reports.officeRentUnitsizeWise'"
      [tableType]="'officeRent'" [report_category]="propertyCategory.MultiStoryOffice"></app-rent-unit-size-wise>
  </div>

  <!-- Retail Rent - unit size wise -->
  <div class="report-model report-tabsection-d" id="{{ officePropertyDetailMenuEnum.retailRentUnitSizeWise}}"
    [ngClass]="{ 'scroll': currentScroll === officePropertyDetailMenuEnum.retailRentUnitSizeWise}" *ngIf="showRetailRent">
    <app-rent-unit-size-wise [propertyInfo]="propertyInfo" [tableHeading]="'reports.retailRentUnitsizeWise'"
      [tableType]="'retailRent'" [report_category]="propertyCategory.MultiStoryOffice" (retailRentSection)="retailRentSec($event)"></app-rent-unit-size-wise>
  </div>
</div>